export const BATCH_TYPE = {
  audit: 1,
  download: 2,
  export: 3,
  operation: 99,
}
